module.exports = __webpack_public_path__ + "img/horizontal_3_5_8017.b6f50556.png";